import { Component, HostListener, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

export class Language {
  constructor(
    public code: string,
    public name: string,
    public flag: string,
    public flagSquare: string
  ) { }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  spinnerTemplate = "<img src='assets/images/logos/mv_logo_100-100.gif'/>";

  constructor() {
    
  }

  ngOnInit(): void {
  }
}
